import RichSearch from "@/components/common/RichSearch";
import { 후기_리치서치_컨텐츠들 } from "@/constants/richSearch/review";
import { HomeContainer } from "@/containers/HomeContainer";
import {
  ReviewOmitContentType,
  getReviewRichSearch,
  AggregateRatingVariable,
  getAggregateRating,
} from "@/utils/richSearch";
import reviewData from "goi_common/src/constants/reviewCount.json";

import Head from "next/head";

export async function getStaticProps() {
  return {
    props: {
      pageOgTitle: "숨김없는 장례의 시작, 고이",
      pageDescription:
        "막막한 상황, 고이가 함께 합니다. 장례식장, 장지(납골당) 추천부터 상조 서비스, 장례 상담, 임종 접수까지. 숨김없는 장례의 시작, 고이(고이장례연구소)",
      pageKeywords:
        "고이, 고이 상조, 고이장례연구소, 고이장례문화원, 고이장례연구소 장례, 장례식장, 장지, 납골당, 상조, 상조 서비스, 장례 상담, 임종 접수",
    },
  };
}

function HomePage({ pageOgTitle }: { pageOgTitle: string }) {
  const reviewRichSearchData: ReviewOmitContentType[] = 후기_리치서치_컨텐츠들.전체.map(
    (reviewBody, index) => ({
      reviewBody,
      author: {
        "@type": "Person",
        name: "상주" + index,
      },
    }),
  );

  const reviewRichSearch = getReviewRichSearch(pageOgTitle, reviewRichSearchData);
  const reviewCountString = String(reviewData.count);
  const aggregateRatingVariable: AggregateRatingVariable = {
    name: pageOgTitle,
    aggregateRating: {
      "@type": "AggregateRating",
      bestRating: "5",
      ratingCount: reviewCountString,
      ratingValue: "4.97",
      reviewCount: reviewCountString,
    },
  };
  const aggregateRating = getAggregateRating("Product", aggregateRatingVariable);

  const aggregateRatingAndReview = { ...aggregateRating, ...reviewRichSearch };

  return (
    <>
      <RichSearch data={aggregateRatingAndReview} />
      <RichSearch
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "고이장례연구소",
          alternateName: "장례의 모든 것, 고이장례연구소",
          url: "https://www.goifuneral.co.kr/",
        }}
      />

      <Head>
        <meta property="og:url" content="https://www.goifuneral.co.kr/" />
        <link rel="canonical" href="https://www.goifuneral.co.kr/" key="canonical" />
      </Head>
      <HomeContainer name="goi" />
    </>
  );
}

export default HomePage;
